import type { ElementType } from 'react';
import { Box } from '@mantine/core';
import { IconBookmark, IconBoxSeam, IconCompass, IconHome, IconScan, IconSearch } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '@/contexts/user-context';

interface Tab {
  to: string;
  label: string;
  icon: ElementType;
  requiresAuth?: boolean;
}

const TABS: Tab[] = [
  { to: '/', label: 'Home', icon: IconHome },
  { to: '/expansions', label: 'Expansions', icon: IconCompass },
  { to: '/collections', label: 'Collection', icon: IconBoxSeam },
  { to: '/search', label: 'Search', icon: IconSearch },
  // Mobile-only entry point for the web card scanner (this bar only renders
  // below the mobile breakpoint, so desktop never sees a Scan tab).
  { to: '/scanner', label: 'Scan', icon: IconScan },
  { to: '/bindings', label: 'Binders', icon: IconBookmark, requiresAuth: true },
];

export function BetaMobileTabs() {
  const location = useLocation();
  const { user, error } = useUser();
  const authed = Boolean(user) && !error;
  return (
    <Box component="nav" className="beta-mobile-tabs" aria-label="Primary mobile">
      {TABS.filter((tab) => !tab.requiresAuth || authed).map((tab) => {
        const active =
          tab.to === '/'
            ? location.pathname === '/'
            : location.pathname === tab.to || location.pathname.startsWith(tab.to + '/');
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`beta-mobile-tab${active ? ' active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <tab.icon size={21} stroke={active ? 2 : 1.5} />
            {tab.label}
          </Link>
        );
      })}
    </Box>
  );
}
